var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: "",
        "hide-overlay": "",
        transition: "dialog-bottom-transition",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-actions",
            {
              staticClass: "mt-0 px-2 py-0 white",
              staticStyle: {
                position: "fixed",
                inset: "0 0 auto 0",
                "z-index": "1",
              },
            },
            [
              _c("v-card-title", { staticClass: "red--text darken-4" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.item == null
                        ? ""
                        : _vm.item.group + "/" + _vm.item.name
                    ) +
                    " "
                ),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { text: "" },
                  on: { click: _vm.onClose },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 white--text",
                  attrs: { color: "blue", disabled: !_vm.canApply },
                  on: { click: _vm.onPressApply },
                },
                [_vm._v(" Apply ")]
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "pa-0 mt-16" },
            [
              _c(
                "v-card",
                { attrs: { elevation: "0", width: "100%" } },
                [
                  _c(
                    "v-card-actions",
                    { staticClass: "py-0" },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "blue--text overline font-weight-black",
                          attrs: { width: "50%", elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-actions",
                            [
                              _c("v-simple-checkbox", {
                                attrs: {
                                  ripple: false,
                                  value: _vm.resolved.a,
                                  color: "blue",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onCheck("a")
                                  },
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.configA == null ? "" : _vm.configA.group
                                  ) +
                                  " "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-card",
                        {
                          staticClass:
                            "orange--text overline font-weight-black",
                          attrs: { width: "50%", elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-actions",
                            { staticClass: "py-0" },
                            [
                              _c("v-simple-checkbox", {
                                attrs: {
                                  ripple: false,
                                  value: _vm.resolved.b,
                                  color: "orange",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onCheck("b")
                                  },
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.configB == null ? "" : _vm.configB.group
                                  ) +
                                  " "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-card-text", { staticClass: "py-0" }, [
                    _c("div", {
                      staticClass: "diff2html-container d2h-dark",
                      domProps: { innerHTML: _vm._s(_vm.renderedDiff) },
                    }),
                  ]),
                  _c("v-divider", { staticClass: "my-2" }),
                  _c(
                    "v-card",
                    {
                      staticClass:
                        "purple--text text--darken-1 mx-2 overline font-weight-black",
                      attrs: { elevation: "0" },
                    },
                    [
                      _c(
                        "v-card-actions",
                        { staticClass: "py-0" },
                        [
                          _c("v-simple-checkbox", {
                            attrs: {
                              ripple: false,
                              value: _vm.isCustomNow,
                              color: "blue",
                              disabled: "",
                            },
                          }),
                          _vm._v(" CUSTOM "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "pt-2" },
                    [
                      _c("codemirror", {
                        staticClass: "cm-editor",
                        attrs: { options: _vm.cmOpt },
                        model: {
                          value: _vm.stringC,
                          callback: function ($$v) {
                            _vm.stringC = $$v
                          },
                          expression: "stringC",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-card-actions", [_c("v-spacer"), _c("v-spacer")], 1),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }